import { Box, HelpLinkIFrame, ModalHeader, Typo, useModal } from '@wrisk/ui-components'
import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'

import { CoverOption, Quote } from '../../../domain'
import {
  tCovers,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import {
  getOptionalCoverLink,
  getOptionalCoversContentBaseUrl,
  useConfig,
} from '../../../state/configuration'
import { useProduct } from '../../product/productContext'

export const useOptionalCoverModal = (quote: Quote) => {
  const { t } = useWriskTranslation()
  const { show } = useModal()
  const { scheme } = useProduct()

  const contentBaseUrl = useConfig(getOptionalCoversContentBaseUrl(scheme.schemeCode))

  return useCallback(
    (coverOption: CoverOption) => {
      const link =
        coverOption.insurer &&
        getOptionalCoverLink(contentBaseUrl, quote.wordingVersion, {
          ...coverOption,
          insurer: coverOption.insurer,
        })

      return coverOption.available
        ? show({
            content: <HelpLinkIFrame src={link} />,
            variant: 'iframe',
          })
        : show({
            content: (
              <Box>
                <ModalHeader
                  header={t(tCovers(coverOption.coverGroup, 'unavailable', 'header'))}
                />
                <Typo>
                  <Trans
                    t={t}
                    i18nKey={tCovers(
                      coverOption.coverGroup,
                      'unavailable',
                      'description',
                    )}
                  />
                </Typo>
              </Box>
            ),
          })
    },
    [show, t, contentBaseUrl],
  )
}
